import React, { Fragment, useState, useRef, useEffect, useContext, useCallback } from "react";

import { AppContext } from "../../../../components/AppProvider";
import { _API, _CK, _U } from "../../../../modules/utils";
import swal from "sweetalert";
import moment from "moment";
import styled from "styled-components";
import cx from "classnames";
import TextareaAutosize from "react-textarea-autosize";
import "perfect-scrollbar/css/perfect-scrollbar.css";

import replyImg from "../../../../resources/console/images/icon/icon-s-reply.svg";
import replystImg from "../../../../resources/console/images/icon/st-reply.svg";
import replycountImg from "../../../../resources/console/images/icon/icon-s-replycount.svg";
import replycountOnImg from "../../../../resources/console/images/icon/icon-s-replycount-on.svg";
import replydelImg from "../../../../resources/console/images/icon/icon-s-delete-2.svg";
import { isEmpty } from "lodash";

export default (props) => {
  const { iam } = useContext(AppContext);
  const { consoleCfg, activeTab } = props;
  const [isSendProc, setIsSendProc] = useState(false);
  const [questionList, setQuestionList] = useState([]);
  const [questionReplyContent, setQuestionReplyContent] = useState({});
  const [questionContent, setQuestionContent] = useState("");
  const [moreView, setMoreView] = useState({ nextPage: 0, pagePerCount: 20 });
  const [totalCount, setTotalCount] = useState(0);
  const [remainListCount, setRemainListCount] = useState(0);
  const [myQuestion, setMyQuestion] = useState({ onOff: "N" });
  const [toggleMenu, setToggleMenu] = useState({});
  const [forceUpdate, setForceUpdate] = useState(0); // 🔧 강제 리렌더링용

  const isBilingual = consoleCfg?.siteIdx == 125;

  // siteIdx 135: isBilingual === true 면 영문, 아니면 한글 라벨/메시지
  const T = {
    question: isBilingual ? "Question" : "질문",
    questionPlaceholder: isBilingual ? "Please enter your question" : "질문을 입력해 주세요",
    submit: isBilingual ? "Submit" : "등록",
    allQuestions: isBilingual ? "All Questions" : "전체질문보기",
    myQuestions: isBilingual ? "My Questions" : "내질문보기",
    comment: isBilingual ? "Comment" : "댓글",
    commentCount: isBilingual ? "Comment count" : "댓글갯수",
    hideComments: isBilingual ? "Hide Comments" : "댓글숨기기",
    viewComments: isBilingual ? "View Comments" : "댓글보기",
    recallPreQuestion: isBilingual ? "Recall Pre-question" : "사전질문 회수",
    delete: isBilingual ? "Delete" : "삭제",
    writeComment: isBilingual ? "Write Comment" : "댓글쓰기",
    commentPlaceholder: isBilingual ? "Please enter your comment" : "댓글을 입력해 주세요",
    cancel: isBilingual ? "Cancel" : "취소",
    noQuestions: isBilingual ? "No questions yet." : "질문이 없습니다.",
    more: isBilingual ? "View More" : "더보기",
    guest: isBilingual ? "Guest" : "게스트",
    emptyQuestion: isBilingual ? "The question field is empty." : "질문란이 비어있습니다.",
    confirmDeleteQuestion: isBilingual
      ? "Are you sure you want to delete this question?"
      : "해당 질문을 삭제하시겠습니까?",
    confirmDeleteComment: isBilingual
      ? "Are you sure you want to delete this comment?"
      : "해당 댓글을 삭제하시겠습니까?",
    enterReply: isBilingual ? "Please enter a reply." : "답변을 입력해 주세요.",
  };

  // 🔧 중복 API 호출 방지 (PC/모바일 Qna가 동시 렌더링되어 2번 호출되는 문제 해결)
  const isInitialLoadDone = useRef(false);
  const hasLoadedInitialQuestions = useRef(false);
  const myRegId = iam.memAuth === "ADMIN" ? iam.idx : iam.preregIdx;

  console.log(consoleCfg);

  const isVisibleQuestion = useCallback((question, onOff = myQuestion.onOff) => {
    if (!question) {
      return false;
    }

    if (onOff === "Y") {
      return question.regId === myRegId;
    }

    if (iam.memAuth === "ADMIN") {
      return true;
    }

    return question.questionStatus === "REQUEST" || question.regId === myRegId;
  }, [iam.memAuth, myQuestion.onOff, myRegId]);

  const getVisibleQuestionCount = useCallback((list, onOff = myQuestion.onOff) => {
    if (!Array.isArray(list)) {
      return 0;
    }

    return list.filter((question) => isVisibleQuestion(question, onOff)).length;
  }, [isVisibleQuestion, myQuestion.onOff]);

  const visibleQuestionList = questionList.filter((question) =>
    isVisibleQuestion(question, myQuestion.onOff)
  );
 
  const onSetQuestionContent = (e) => {
    if (e.target.value.length <= 500) {
      setQuestionContent(e.target.value);
    }
  };

  const myQuestionView = (e, value) => {
    
    if (e) e.preventDefault();

    // 이미 선택된 탭이면 무시
    if (myQuestion.onOff === value) {
      return;
    }

    // 상태 업데이트만 하면 됨 - 렌더링 조건에서 알아서 필터링됨
    setMyQuestion({ onOff: value });
    
    // 🔧 카운트 재계산 (필터링된 질문 수)
    setTotalCount(getVisibleQuestionCount(questionList, value));
  };

  const onSetNextPage = (e) => {
    let num = 0;
    if(document.body.clientWidth+15 < 568){
      num = $(".m_qna_container .question_list_inner_box").length;
    }else{
      num = $(".pc_qna_container .question_list_inner_box").length;
    }
    setMoreView((o) => {
      return { ...o, ["nextPage"]: num };
    });
  };

  const loadQuestionList = (item) => {
    let nextPage = 0;
    let pagePerCount = 0;

    if(item){
      nextPage = item.nextPage;
      pagePerCount = item.pagePerCount;
    } else {
      nextPage = moreView.nextPage;
      pagePerCount = moreView?.pagePerCount;
    }


    const req = {
      path: "/v1/client/question/list",
      data: {
        eventIdx: consoleCfg.eventIdx,
        sessionIdx: consoleCfg.sessionIdx,
        myQuestion: myQuestion.onOff,
        pagePerCount: pagePerCount,
        nextPage: nextPage,
      },
    };

    _API.post(req).then((res) => {
      let { data, totalCount, remainListCount } = res.data;

      setRemainListCount(remainListCount);

      if (data.length > 0) {
        if(item && item.gubun == "INSERT"){

          // 🔧 덮어쓰지 않고 기존 리스트와 merge (race 상황에서 기존 항목 유지)
          setQuestionList((o) => {
            const seen = new Set();
            const merged = [];
            for (const q of data) {
              if (q && q.idx != null && !seen.has(q.idx)) {
                seen.add(q.idx);
                merged.push(q);
              }
            }
            for (const q of o) {
              if (q && q.idx != null && !seen.has(q.idx)) {
                seen.add(q.idx);
                merged.push(q);
              }
            }
            setTotalCount(getVisibleQuestionCount(merged));
            return merged;
          });
          hasLoadedInitialQuestions.current = true;

        }else{
          setQuestionList((o) => {
            // 🔧 idx 기반 dedup merge (race 상황에서 중복 삽입 방지)
            const seen = new Set();
            const nb = [];
            for (const q of o) {
              if (q && q.idx != null && !seen.has(q.idx)) {
                seen.add(q.idx);
                nb.push(q);
              }
            }
            for (const q of data) {
              if (q && q.idx != null && !seen.has(q.idx)) {
                seen.add(q.idx);
                nb.push(q);
              }
            }

            // 🔧 클라이언트에서 카운트 재계산
            setTotalCount(getVisibleQuestionCount(nb));

            return nb;
          });
          if (!item) {
            hasLoadedInitialQuestions.current = true;
          }
        }
      } else if (item && item.gubun == "INSERT") {
        setQuestionList([]);
        setTotalCount(0);
        hasLoadedInitialQuestions.current = true;
      }

      if(moreView?.pagePerCount == 10){
        setMoreView((o) => {
          return {...o, ['pagePerCount'] : 5}
        })
      }
    });
  };

/*   const questionSave = () => {

    const req = {
      path: "/v1/client/question/save",
      data: {
        eventIdx: consoleCfg.eventIdx,
        sessionIdx: consoleCfg.sessionIdx,
        consoleIdx: consoleCfg.consoleIdx,
        name: iam.name,
        questionerType: iam.memAuth === "ADMIN" ? "MANAGER" : "ATTENDER",
        questionStatus: iam.memAuth == "ADMIN" ? "REQUEST" : "WAIT",
        content: questionContent,
        regId: iam?.preregIdx,
      },
    };

    _API.post(req).then((res) => {
      let { totalCount, find } = res.data;
      if ( totalCount > 0 ) {
        let item = {division : "QUESTION" , detail : "INSERT"};
        onSend(item);
        setQuestionContent("");
      }
    });
  }; */

  const questionSave = () => {

    // 🔍 사용자 타입에 따른 올바른 ID 사용
    // 관리자: T_MEMBER.IDX (iam.idx 필드)  
    // 일반사용자: T_PREREG_INFO.IDX (iam.preregIdx 필드)
    const correctRegId = iam.memAuth === "ADMIN" ? iam.idx : iam.preregIdx;

    let item = {division : 'QUESTION', detail : 'INSERT', 
                cName : iam.name, content : questionContent, questionerType: iam.memAuth === "ADMIN" ? "MANAGER" : "ATTENDER",
                questionStatus : iam.memAuth == "ADMIN" ? "REQUEST" : "WAIT",
                answerYn : iam.memAuth == "ADMIN" ? 'Y' : "N",
                regId : correctRegId
              }

    if(!questionContent || questionContent.trim() === "") {
      alert(T.emptyQuestion);
      return false;
    }

    onSend(item);

    setQuestionContent("");


  };

/*   const questionSetShow = (item) => {

    console.log(item);

    const req = {
      path: "/v1/client/question/save",
      data: {
        idx: item.idx,
        eventIdx: consoleCfg.eventIdx,
        sessionIdx: consoleCfg.sessionIdx,
        consoleIdx: consoleCfg.consoleIdx,
        questionStatus: item.questionStatus,
        regId: iam?.preregIdx,
      },
    };

    _API.post(req).then((res) => {
      let { find } = res.data;
      if ( find ) {
        let item = {division : "QUESTION" , detail : "ONOFF", find : find};
        onSend(item);
      }
    }); 

  }; */

  const questionSetShow = (param) => {

    const correctRegId = iam.memAuth === "ADMIN" ? iam.idx : iam.preregIdx;
    
    let item;
    
    // 🚀 사전질문인 경우: 회수(REMOVE) 처리 (preQuestionCollection 방식)
    if (param.questionGubun === 'PRE' && param.preIdx) {
      item = {
        direction: "live", 
        division: "QUESTION", 
        detail: "REMOVE", 
        idx: param.idx,  // 라이브로 이동된 질문 ID (submittedIdx 역할)
        questionStatus: param.questionStatus, 
        preIdx: param.preIdx  // 원본 사전질문 ID
      };
    
    } else {
      // 일반 질문인 경우: ONOFF 처리
      item = {
        direction: param.questionStatus == 'WAIT' ? 'live' : 'review',
        idx: param.idx, 
        division: "QUESTION", 
        detail: "ONOFF", 
        regId: correctRegId, 
        questionStatus: param.questionStatus == "REQUEST" ? "WAIT" : "REQUEST"
      };
     
    }
    
   

    onSend(item);

  };
  
  /* const removeQna = (tableName, val) => {

    var confirmChkTxt = tableName == "T_QUESTION" ? "해당 질문을 삭제하시겠습니까?" : "해당 댓글을 삭제하시겠습니까?";

    if (window.confirm(confirmChkTxt)) {
      const req = {
        path: "/v1/client/question/delete",
        data: {
          eventIdx: consoleCfg.eventIdx,
          sessionIdx: consoleCfg.sessionIdx,
          tableName: tableName,
          idx: val.idx,
        },
      };

      _API.post(req).then((res) => {
        let { data } = res;

        if (data > 0) {
          let item = {division : tableName == "T_QUESTION" ? "QUESTION" : "COMMENT" , detail : "REMOVE", idx : val.idx, questionStatus : val.questionStatus};
          onSend(item);
          if (!val.idx) {
            $(".qna.scroll-wrap")[0].scrollTop = 0;
          }
        }
      });
    }
  }; */

  const removeQna = (val) => {

    var confirmChkTxt = T.confirmDeleteQuestion;

    if (window.confirm(confirmChkTxt)) {

      let item = {division : "QUESTION" , detail : "REMOVE", idx : val.idx, preIdx :val.preIdx};
      
      onSend(item);

      if (!val.idx) {
        $(".qna.scroll-wrap")[0].scrollTop = 0;
      }

    }

  };

  const removeComment = (val) => {

    var confirmChkTxt = T.confirmDeleteComment;

    if (window.confirm(confirmChkTxt)) {

      let item = {division : "COMMENT" , detail : "REMOVE", idx : val.idx, tQuestionIdx : val.tQuestionIdx};
      
      onSend(item);

      if (!val.idx) {
        $(".qna.scroll-wrap")[0].scrollTop = 0;
      }

    }

  };

  const questionCommentSetShow = (data) => {

    const correctModId = iam.memAuth === "ADMIN" ? iam.idx : iam.preregIdx;

    const item = {};

    item.eventIdx = consoleCfg.eventIdx;
    item.sessionIdx = consoleCfg.sessionIdx;
    item.consoleIdx = consoleCfg.consoleIdx;
    item.idx = data.idx;
    item.tQuestionIdx = data.tQuestionIdx;
    item.content = data.contents;
    item.regId = data.regId;  // 🔧 원본 작성자 ID 유지
    item.modId = correctModId;  // 🔧 수정자 ID 별도 관리
    item.showYn = data.showYn == 'Y' ? 'N' : 'Y' 
    item.detail = "UPDATE";
    item.division = 'COMMENT';
    item.regDate = data.regDate;  // 🔧 원본 작성일 유지
    item.modDate = new Date();  // 🔧 수정일 별도 관리
    item.writeLocation = "CONSOLE";

    setQuestionContent("");
    if (item.answerYn === "Y") {
        changeReplyContent(item, "");
    }

    onSend(item);

    if (!data.idx) {
        $(".qna.scroll-wrap")[0].scrollTop = 0;
    }



 /*    if (item?.showYn) {
      commentSave({
        idx: item.idx,
        showYn: item?.showYn === "Y" ? "N" : "Y",
        eventIdx: consoleCfg?.eventIdx,
        sessionIdx: consoleCfg?.sessionIdx,
        consoleIdx: consoleCfg?.consoleIdx,
        questionGubun: item.questionGubun,
        questionerType: item.questionerType,
        name: item.name,
        contents: item.contents,
        sort: item.sort,
        regId: item.regId,
        regDate: item?.regDate,
        tQuestionIdx: item.tQuestionIdx,
        saveGubun: "UPDATE",
      });
    } */

  };

  /* const commentSave = (item) => {
    const req = {
      path: "/v1/client/comment/save",
      data: {
        idx: item.idx,
        eventIdx: item.eventIdx,
        sessionIdx: item.sessionIdx,
        consoleIdx: item.consoleIdx,
        tQuestionIdx: item.tQuestionIdx,
        contents: item.contents,
        regId: item.regId,
        regDate: item.regDate,
        showYn: item.showYn,
        writeLocation: "CONSOLE",
        name: item.name,
      },
    };

    _API.post(req).then((res) => {
      let { data } = res;
      if (data > 0) {
        setQuestionContent("");
        if (item.answerYn === "Y") {
          changeReplyContent(item, "");
        }
        item.division = "COMMENT";
        item.idx = data;
        onSend(item);
        if (!item.idx) {
          $(".qna.scroll-wrap")[0].scrollTop = 0;
        }
      }
    });
  }; */

  const commentSave = (data) => {

    const correctRegId = iam.memAuth === "ADMIN" ? iam.idx : iam.preregIdx;

    const item = {};

    item.eventIdx = consoleCfg.eventIdx;
    item.sessionIdx = consoleCfg.sessionIdx;
    item.consoleIdx = consoleCfg.consoleIdx;
    item.questionIdx = data.idx;
    item.content = questionReplyContent[`answerContent-${data.idx}`];
    item.regId = correctRegId;
    item.showYn = iam?.memAuth == 'ADMIN' ? 'Y' : "N";
    item.detail = "INSERT";
    item.division = 'COMMENT';
    item.regDate = new Date();
    item.writeLocation = "CONSOLE";

    setQuestionContent("");
    if (item.answerYn === "Y") {
        changeReplyContent(item, "");
    }

    onSend(item);

    if (!data.idx) {
        $(".qna.scroll-wrap")[0].scrollTop = 0;
    }

  };

  const changeReplyContent = (item, value) => {
    const key = `answerContent-${item.idx}`;
    if (value.length <= 300) {
      setQuestionReplyContent((o) => {
        return { ...o, [key]: value };
      });
    }
  };

  const questionReply = (item) => {

    if (!questionReplyContent[`answerContent-${item.idx}`]) {
      swal(T.enterReply);
      return;
    }

    commentSave(item);

    questionReplyContent[`answerContent-${item.idx}`] = "";

  /*   setQuestionList((o) => {
      const nb = [...o];
      for (let i in nb) {
        if (nb[i].idx == item.idx) {
          nb[i].commentListShowYn = "N";
          nb[i].showCommentWriteBox = false;
        }
      }
      return nb;
    }); */

  };

  const setCommentListShowYn = (i) => {
    setQuestionList((o) => {
      const nb = [...o];
      nb[i].commentListShowYn = nb[i]?.commentListShowYn === "Y" ? "N" : "Y";
      return nb;
    });
  };

  const onSend = (item) => {
    // 질문 등록 시에만 내용 확인
    if (item.detail === 'INSERT' && item.division === 'QUESTION') {
      if (!questionContent || questionContent.trim() === "") {
        return;
      }
    }

    // 댓글 등록 시에만 댓글 내용 확인
    if (item.detail === 'INSERT' && item.division === 'COMMENT') {
      if (!item.content || item.content.trim() === "") {
        return;
      }
    }

    if (isSendProc) {
      return;
    }

    setIsSendProc(true);
    _U.postMessage("SOCKET-SEND", {
      action: "FMS",
      data: {
        mode: "FMS",
        siteIdx: consoleCfg?.siteIdx,
        eventIdx: consoleCfg?.eventIdx,
        sessionIdx: consoleCfg?.sessionIdx,
        consoleIdx: consoleCfg?.consoleIdx,
        name: iam?.name,
        memType: iam?.memType,
        companyName: iam?.companyName,
        deptName: iam?.deptName,
        memberIdx: iam?.idx,
        item: item,
      },
    });
    setIsSendProc(false);
  };

  const showTogleReplyWrap = (item) => {
    if (item.idx) $("#reply-wrap-group-" + item.idx).slideToggle();
  };

  
  const onReceivedMessage = (e) => {

    const y = $(window).scrollTop();

    _U.parseMessage(e).then((data) => {
        switch (data.code) {
          case "SOCKET-RECEIVED":
            return data.data ? JSON.parse(data.data) : null;
        }
      }).then((data) => {

        // 원본 데이터 보존 (updatedQuestions, updatedQuestion 등을 잃지 않기 위해)
        let originalData = data;
        if(data != null && data.action != null){
          data = data?.data
        }

        // 업데이트된 데이터는 원본에서 가져오기
        const updatedQuestion = originalData?.updatedQuestion;
        const updatedQuestions = originalData?.updatedQuestions;
        const liveList = originalData?.updatedQuestions?.liveList;
        const reviewList = originalData?.updatedQuestions?.reviewList;
        const stats = originalData?.stats;

        if (data?.mode === "FMS" && data?.eventIdx == consoleCfg.eventIdx && data?.sessionIdx == consoleCfg.sessionIdx) {
          if(data?.item.division === "QUESTION"){
            if(data?.item.detail === "INSERT"){
              if (!hasLoadedInitialQuestions.current) {
                loadQuestionList({
                  nextPage: 0,
                  pagePerCount: 10,
                  gubun: "INSERT",
                });
                return;
              }

              const candidateQuestions = [];

              if (updatedQuestions) {
                const { consoleList, reviewList, liveList } = updatedQuestions;

                if (Array.isArray(consoleList) && consoleList.length > 0) {
                  candidateQuestions.push(...consoleList);
                }
                if (Array.isArray(reviewList) && reviewList.length > 0) {
                  candidateQuestions.push(...reviewList);
                }
                if (Array.isArray(liveList) && liveList.length > 0) {
                  candidateQuestions.push(...liveList);
                }
              }

              if (updatedQuestion) {
                candidateQuestions.push(updatedQuestion);
              }

              if (candidateQuestions.length > 0) {
                
                setQuestionList((prevList) => {
                  
                  const seen = new Set();
                  const merged = [...candidateQuestions, ...prevList];

                  const unique = merged.filter((question) => {
                    if (!question || question.idx == null) {
                      return false;
                    }
                    if (seen.has(question.idx)) {
                      return false;
                    }
                    seen.add(question.idx);
                    return true;
                  });

                  
                  // 🔍 새로 추가된 질문들의 렌더링 조건 확인
                  candidateQuestions.forEach((newQ) => {
                    const willShow = iam.memAuth === "ADMIN" || 
                                     newQ.questionStatus === "REQUEST" || 
                                     newQ.regId === (iam.memAuth === "ADMIN" ? iam.idx : iam.preregIdx);
                  });

                  return unique;
                });

                // 통계 업데이트 - 클라이언트에서 필터링해서 카운트
                setQuestionList((currentList) => {
                  // 관리자: 전체 질문
                  // 참가자: 본인 질문 + 노출된 질문 (SHOW_YN='Y')
                  setTotalCount(getVisibleQuestionCount(currentList));
                  
                  return currentList; // 리스트는 변경하지 않음
                });
                
                // 🔧 강제 리렌더링 트리거
                setForceUpdate(prev => prev + 1);
              } else {
                // Fallback: API 호출 (서버 데이터가 없는 경우에만)
                let item = {
                  nextPage : 0,
                  pagePerCount : 10,
                  gubun : "INSERT",
                }
                loadQuestionList(item);
              } 

            } else if(data?.item.detail === "MOD"){
              
              // 사전질문이 라이브로 이동한 경우 (PreList → Live) - 최적화
              if(data?.item.preIdx && data?.item.isMove) {
                
                // 서버에서 전송한 업데이트된 질문 목록 데이터로 상태 업데이트
                const consoleData = updatedQuestions?.consoleList || updatedQuestions;
                if (consoleData && consoleData.length > 0) {
                  // 🚀 사전질문 라이브 이동 시 기존 리스트에 추가 (덮어쓰기 방지)
                  const movedQuestion = consoleData[0]; // 이동된 질문 1개
                 
                  
                  setQuestionList((prevList) => {
                    // 중복 체크
                    const exists = prevList.some(q => q.idx === movedQuestion.idx);
                    if (!exists) {
                      return [movedQuestion, ...prevList]; // 맨 앞에 추가
                    }
                    return prevList;
                  });
                  
                  // 🔧 통계 업데이트 - 클라이언트에서 재계산
                  setQuestionList((currentList) => {
                    setTotalCount(getVisibleQuestionCount(currentList));
                    return currentList;
                  });
                } else {
                  let item = {
                    nextPage : 0,
                    pagePerCount : 10,
                    gubun : "INSERT",
                  }
                  loadQuestionList(item);
                }
              } else {
                // 일반 질문 수정의 경우 개별 업데이트 (최적화)
                
                if (updatedQuestion) {
                  setQuestionList((o) => {
                    let nb = [...o];
                    for (let i in nb) {
                      if (nb[i].idx == updatedQuestion.idx) {
                        // 댓글 목록 보존하면서 업데이트
                        nb[i] = { ...nb[i], ...updatedQuestion, commentList: nb[i].commentList };
                      }
                    }
                    
                    // 🔧 통계 업데이트 - 클라이언트에서 재계산
                    setTotalCount(getVisibleQuestionCount(nb));
                    
                    return nb;
                  });
                } else {
                  // Fallback: 기존 로직 (서버에서 updatedQuestion을 보내지 않는 경우)
                  setQuestionList((o) => {
                    let nb = [...o];
                    for (let i in nb) {
                      if (nb[i].idx == data?.item?.idx) {
                        // 질문 내용이나 상태가 변경된 경우 업데이트
                        if (data?.item?.content) nb[i].content = data.item.content;
                        if (data?.item?.questionStatus) nb[i].questionStatus = data.item.questionStatus;
                        if (data?.item?.showYn) nb[i].showYn = data.item.showYn;
                        if (data?.item?.answerYn) nb[i].answerYn = data.item.answerYn;
                      }
                    }
                    return nb;
                  });
                }
              }

            } else if(data?.item.detail === "ONOFF"){

              if(data.item.direction == "archiveToReview" || data.item.direction == "archive") {

                // 아카이브 관련 액션은 전체 목록 새로고침 필요 (최적화)
                if (updatedQuestions && updatedQuestions.length > 0) {
           
                  setQuestionList(updatedQuestions);
                  
                  // 🔧 통계 업데이트 - 클라이언트에서 재계산
                  setTotalCount(getVisibleQuestionCount(updatedQuestions));
                } else {
                  let item = {
                    nextPage : 0,
                    pagePerCount : 10,
                    gubun : "INSERT",
                  }
                  loadQuestionList(item);
                }

              } else {
                
                // Live/Review 상태 변경은 개별 업데이트 (최적화)
                if (updatedQuestion) {
                 
                  setQuestionList((o) => {
                    let nb = [...o];
                    let found = false;
                    
                    // 기존 질문 중에서 해당 질문 찾아서 업데이트
                    for (let i in nb) {
                      if (nb[i].idx == updatedQuestion.idx) {
                        // 댓글 목록 보존하면서 업데이트
                        nb[i] = { ...nb[i], ...updatedQuestion, commentList: nb[i].commentList };
                        found = true;
                        break;
                      }
                    }
                    
                    // 🚀 사전질문이 라이브로 이동한 경우: 기존 리스트에 없으면 추가
                    if (!found && data.item.direction === 'live') {
                     
                      nb = [updatedQuestion, ...nb]; // 맨 앞에 추가
                    }
                    
                    // 🔧 통계 업데이트 - 클라이언트에서 재계산
                    setTotalCount(getVisibleQuestionCount(nb));
                    
                    return nb;
                  });
                } else {
                  // Fallback: 기존 로직 (서버에서 updatedQuestion을 보내지 않는 경우)
                
                  // 🚨 사전질문 라이브 이동 시 updatedQuestion이 없는 경우 전체 리스트 재로드
                  if (data.item.direction === 'live') {
                  
                    let item = {
                      nextPage: 0,
                      pagePerCount: 10,
                      gubun: "INSERT",
                    };
                    loadQuestionList(item);
                    return; // 여기서 종료
                  }
                  
                  setQuestionList((o) => {
                    let nb = [...o];
                    if(nb?.filter((q) => q.idx == data?.item.idx)?.length > 0){
                      for (let i in nb) {
                        if (nb[i].idx == data?.item.idx) {
                          nb[i].questionStatus = data?.item.questionStatus;
                        }
                      }
                    }
                    return nb;
                  });
                }

              }

            } else if(data?.item.detail === "REMOVE"){
              
              // 질문 목록에서 제거 (최적화)
              setQuestionList((prevList) => {
                const newList = prevList.filter(question => question.idx !== data?.item?.idx);
                
                // 🔧 통계 업데이트 - 클라이언트에서 재계산
                setTotalCount(getVisibleQuestionCount(newList));
                
                return newList;
              });
            }  
          } else if(data?.item.division == "COMMENT") {
            if(data?.item.detail == 'INSERT') {

  
              // 서버에서 전송한 댓글 데이터와 업데이트된 질문 데이터로 상태 업데이트 (최적화)
              const commentData = originalData?.commentData;
              
         

              if (commentData && updatedQuestion) {
                setQuestionList((o) => {
                  
                  // 🔧 불변성을 유지하면서 업데이트
                  const nb = o.map((question) => {
                    if (question.idx == updatedQuestion.idx) {
                      
                      // 기존 댓글 목록 가져오기
                      const existingComments = question.commentList || [];
                      
                      // 중복 체크
                      const exists = existingComments.some(c => c.idx === commentData.idx);
                      
                      let newCommentList;
                      if (!exists) {
                        // 🔧 name 필드 추가 (commentData에 없을 경우를 대비)
                        const commentWithName = {
                          ...commentData,
                          name: commentData.name || data.name || null
                        };
                        // 🔧 새 배열 생성 (불변성 유지)
                        newCommentList = [...existingComments, commentWithName];
                      } else {
                        newCommentList = existingComments;
                      }
                      
                      // 🔧 새 객체 반환 (불변성 유지)
                      const newQuestion = {
                        ...question,
                        ...updatedQuestion,
                        commentList: newCommentList,
                        commentListShowYn: "Y",
                        showCommentWriteBox: false
                      };
                      
                      return newQuestion;
                    }
                    return question;
                  });
                  
                  return nb;
                });
              } else {
                setQuestionList((o) => {
                  // 🔧 불변성을 유지하면서 업데이트
                  const nb = o.map((question) => {
                    if (question.idx == data?.item?.questionIdx) {
                      
                      let cData =  {
                        idx : data.insertGetId,
                        tQuestionIdx: data.item.questionIdx,
                        contents: data.item.content,
                        regId: data.item.regId,
                        regDate: data.item.regDate,
                        modId: data.item.regId,
                        modDate: data.item.regDate,
                        showYn: data.item.showYn,
                        name: data.name
                      }

                      // 기존 댓글 목록 가져오기
                      const existingComments = question.commentList || [];
                      
                      // 중복 체크
                      const exists = existingComments.some(c => c.idx === cData.idx);
                      
                      let newCommentList;
                      if (!exists) {
                        // 🔧 새 배열 생성 (불변성 유지)
                        newCommentList = [...existingComments, cData];
                      } else {
                        newCommentList = existingComments;
                      }

                      // 🔧 새 객체 반환 (불변성 유지)
                      return {
                        ...question,
                        commentList: newCommentList,
                        commentListShowYn: "Y",
                        showCommentWriteBox: false
                      };
                    }
                    return question;
                  });
                  
                  return nb;
                });
              }
              
              // 🔧 강제 리렌더링 트리거
              setForceUpdate(prev => prev + 1);
            } else if(data?.item.detail == 'REMOVE') {

              // 서버에서 전송한 업데이트된 질문 데이터로 상태 업데이트 (최적화)
              if (updatedQuestion) {
                setQuestionList((o) => {
                  const nb = [...o];
                  for (let i in nb) {
                    if (nb[i].idx == updatedQuestion.idx) {
                      // 질문 정보 업데이트 (commentCnt 포함)
                      nb[i] = { ...nb[i], ...updatedQuestion };
                      
                      // 댓글 목록에서 삭제된 댓글 제거
                      if (nb[i]?.commentList) {
                        nb[i].commentList = nb[i].commentList.filter(
                          comment => comment.idx !== data?.item?.idx
                        );
                      }
                    }
                  }
                  return nb;
                });
              } else {
                setQuestionList((o) => {
                  const nb = [...o];
                  for (let i in nb) {
                    if (nb[i].idx == data?.item?.tQuestionIdx) {
                      // 댓글 목록에서 삭제된 댓글 제거 (최적화)
                      if (nb[i]?.commentList) {
                        nb[i].commentList = nb[i].commentList.filter(
                          comment => comment.idx !== data?.item?.idx
                        );
                      }
                    }
                  }
                  return nb;
                });
              }

            } else if(data?.item.detail == 'UPDATE') {

              // 서버에서 updatedQuestion을 보내지 않으므로 기존 로직 유지하되 최적화
              setQuestionList((o) => {
                const nb = [...o];

                for (let i in nb) {
                  if (nb[i].idx == data?.item?.tQuestionIdx) {
                    // 댓글 목록에서 해당 댓글 업데이트 (최적화)
                    if (nb[i]?.commentList) {
                      nb[i].commentList = nb[i].commentList.map(comment => {
                        if (comment.idx === data?.item?.idx) {
                          return {
                            ...comment,
                            idx: data.item.idx,
                            tQuestionIdx: data.item.tQuestionIdx,
                            contents: data.item.content,
                            regId: data.item.regId,  // 원본 작성자 ID 유지
                            regDate: data.item.regDate,  // 원본 작성일 유지
                            modId: data.item.modId,  // 수정자 ID
                            modDate: data.item.modDate,  // 수정일
                            showYn: data.item.showYn,
                            name: data.name
                          };
                        }
                        return comment;
                      });
                    }
                  }
                }
                return nb;
              });

            }

          }
        }

        // 🔍 아래 로직들은 위에서 최적화된 로직으로 대체됨 (중복 처리 방지용 주석)
        /*
        //COMMENT 때문에 살려둠
        if (data?.item?.saveGubun === "INSERT") {
          if (data?.item?.division === "QUESTION") {
            if (
              data?.item?.showYn === "Y" ||
              iam.memAuth == "ADMIN" ||
              data?.item?.regId == iam.preregIdx
            ) {
              setTotalCount((o) => {
                return ++o;
              });
            }
            const tmp = [];
            tmp.push(data.item);
            setQuestionList((o) => {
              const nb = [...o];
              for (let i in nb) {
                tmp.push(nb[i]);
              }
              return tmp;
            });
          } else if (data?.item?.division === "COMMENT") {
            setQuestionList((o) => {
              const nb = [...o];
              for (let i in nb) {
                if (nb[i].idx == data?.item?.tQuestionIdx) {
                  if (nb[i]?.commentList) {
                    let length = nb[i]?.commentList
                      ? nb[i]?.commentList?.length
                      : 0;
                    nb[i].commentList[length] = data?.item;
                  } else {
                    let array = new Array();
                    array.push(data?.item);
                    nb[i].commentList = array;
                  }
                }
              }
              return nb;
            });
          }
        } else if (data?.item?.saveGubun === "REMOVE") {
          if (data?.item?.division === "QUESTION") {
            if (
              data?.item?.showYn === "Y" ||
              iam.memAuth == "ADMIN" ||
              data?.item?.regId == iam.preregIdx
            ) {
              setTotalCount((o) => {
                return --o;
              });
            }
            const tmp = [];
            setQuestionList((o) => {
              const nb = [...o];
              for (let i in nb) {
                if (nb[i].idx != data?.item?.idx) {
                  tmp.push(nb[i]);
                }
              }
              return tmp;
            });
          } else if (data?.item?.division === "COMMENT") {
            var tmp = [];
            setQuestionList((o) => {
              const nb = [...o];
              for (let i in nb) {
                if (nb[i].idx == data?.item?.tQuestionIdx) {
                  const nb2 = nb[i].commentList;
                  for (let j in nb2) {
                    if (nb2[j].idx != data?.item?.idx) {
                      tmp.push(nb2[j]);
                    }
                  }
                  nb[i].commentList = tmp;
                }
              }
              return nb;
            });
          }
        } else if (data?.item?.saveGubun === "UPDATE") {
          if (data?.item?.division === "QUESTION") {

            setQuestionList((o) => {
              let nb = [...o];
              if(nb?.filter((q) => q.idx == data?.item?.idx)?.length > 0){
                for (let i in nb) {
                  if (nb[i].idx == data?.item?.idx) {
                    data.item.commentList = nb[i].commentList;
                    nb[i] = data?.item;
                  }
                }
              }else{
                nb.push(data?.item);
                nb = nb.sort((a, b) => b.regDate - a.regDate);
              }
              return nb;
            });
          } else if (data?.item?.division === "COMMENT") {
            setQuestionList((o) => {
              const nb = [...o];
              for (let i in nb) {
                if (nb[i].idx == data?.item?.tQuestionIdx) {
                  const nb2 = nb[i].commentList;
                  for (let j in nb2) {
                    if (nb2[j].idx == data?.item?.idx) {
                      nb[i].commentList[j] = data?.item;
                    }
                  }
                }
              }
              return nb;
            });
          }
        }
        */
        $("body").scrollTop(y);
      });
  }; 

  const setShowCommentWriteBox = (q, showYn) => {
    setQuestionList((o) => {
      const nb = [...o];
      for (let i in nb) {
        if (nb[i].idx == q.idx) {
          nb[i].showCommentWriteBox = showYn;
        }
      }
      return nb;
    });
  };
  
  useEffect(() => {
    window.addEventListener("message", onReceivedMessage);
    return () => {
      window.removeEventListener("message", onReceivedMessage);
    };
  }, [consoleCfg, iam]);

  useEffect(() => {
    if (!isInitialLoadDone.current && moreView?.nextPage === 0) {
      isInitialLoadDone.current = true;
      hasLoadedInitialQuestions.current = false;
      loadQuestionList();
      return;
    }

    if (isInitialLoadDone.current) {
      loadQuestionList();
    }
  }, [moreView?.nextPage]);

  useEffect(() => {
    if (typeof window === "undefined" || window.innerWidth > 767 || activeTab !== 1) {
      return;
    }

    const frameId = window.requestAnimationFrame(() => {
      const listBox = document.querySelector(".question_list_box");
      const videoContainer = document.querySelector(".video_con");

      if (!listBox) {
        return;
      }

      const stickyBottom = videoContainer
        ? Math.max(videoContainer.getBoundingClientRect().bottom, 0)
        : 0;
      const desiredTop = stickyBottom + 16;
      const currentTop = listBox.getBoundingClientRect().top;
      const absoluteTop = window.scrollY + currentTop;

      if (currentTop < desiredTop || currentTop > window.innerHeight) {
        window.scrollTo({
          top: Math.max(0, absoluteTop - desiredTop),
          behavior: "auto",
        });
      }
    });

    return () => window.cancelAnimationFrame(frameId);
  }, [myQuestion.onOff, visibleQuestionList.length, activeTab]);
  
  return (
    <Fragment>
      <div className="qna_container">
        <div className="question_write_box">
          <div className="question_write_box_inner">
            <h2>{T.question}</h2>
            <span>{questionContent.length}/500</span>
          </div>
          <div className="question_box_flex">
            <TextareaAutosize
              type="text"
              maxLength="500"
              placeholder={T.questionPlaceholder}
              value={questionContent}
              onChange={(e) => onSetQuestionContent(e)}
              style={{ overflow: "hidden" }}
            ></TextareaAutosize>
            <button
              type="button"
              id="button-addon22"
              onClick={(e) => questionSave()}
            >
              {T.submit}
            </button>
          </div>
        </div>


        {/* <PerfectScrollbar useBothWheelAxes={false} suppressScrollX={true}> */}
        <div className="question_list_box">
          <div className="question_list_box_title" style={{marginBottom:`${iam?.memAuth == "ADMIN" ? "10px" : "20px"}`}}>
            <ul>
              <li className={cx({ on: myQuestion.onOff !== "Y" })}>
                <a className="all_question" onClick={(e) => myQuestionView(e, "N")}>
                  {T.allQuestions}
                </a>
              </li>
              <li className={cx({ on: myQuestion.onOff === "Y" })}>
                <a className="my_qustion" onClick={(e) => myQuestionView(e, "Y")}>
                  {T.myQuestions}
                </a>
              </li>
            </ul>
            <p>
              {isBilingual ? (
                <><b>{totalCount}</b> question(s) submitted.</>
              ) : (
                <><b>{totalCount}개</b>의 질문이 등록되었습니다.</>
              )}
            </p>
          </div>
          <div className={cx({ question_list_wrapper_box: true, admin_question_list_wrapper_box: iam?.memAuth == "ADMIN"})}>
            {!isEmpty(visibleQuestionList) && visibleQuestionList?.map((item, i) => (
              <Fragment key={item?.idx ?? i}>
                <Fragment>
                  <div
                    className={cx({
                      on: item.questionStatus === "WAIT" && iam.memAuth == "ADMIN",
                      question_list_inner_box: true,
                      active: toggleMenu[item.idx],
                    })}
                    id={`p_question_tab_${item.idx}`}
                  > 
                    <div className={cx({ question_list_box_desc: true})}>
                      <pre>{item.content}</pre>
                      <div className="question_list_box_date_reply">
                        <span className="question_list_box_date_reply_span">
                          {iam.memAuth == "ADMIN" ?(item?.name != null && item?.name != "" ? item?.name : item?.regId) + ' - ' : ""}{moment(item.regDate).format("MM.DD HH:mm:ss")}
                        </span>
                        <em>
                          <i className="demo-icon icon-comment" onClick={(e) => { showTogleReplyWrap(item) }}></i>
                        </em>
                          <div className="question_list_box_desc_btn" style={{ display: item.showCommentWriteBox == true ? "none": "flex",}}>
                            {iam.memAuth == "ADMIN" &&
                              <div className="qna_check_box">
                                <input
                                  type="checkbox"
                                  id={`switch${i}`}
                                  name="switch"
                                  className="input__on-off"
                                  value={item.questionStatus}
                                />
                                <label
                                  htmlFor={`switch${i}`}
                                  className="label__on-off label__on"
                                  style={{ backgroundColor: item?.questionStatus == "REQUEST" ? "#7758fa" : "#999999",}}
                                  // onClick={(e) => questionSetShow(item)}
                                  onClick={(e) => questionSetShow(item)}
                                >
                                  <span
                                    className="marble"
                                    style={{ right: item?.questionStatus == "REQUEST" ? "3px" : "19px",}}
                                  ></span>
                                </label>
                              </div>
                            }
                            <button className="reply_btn" onClick={(e) => setShowCommentWriteBox(item, true)} >
                              <img src={replyImg} alt={T.comment} />
                              <span>{T.comment}</span>
                            </button>
                            {item?.commentList?.filter((c) => iam.memAuth == "ADMIN" || c.regId == iam.preregIdx || c?.showYn === "Y")?.length > 0 && (
                              <button className="reply_count" onClick={(e) => setCommentListShowYn(i)} >
                                <img src={item?.commentListShowYn === "Y" ? replycountOnImg : replycountImg} alt={T.commentCount} />
                                <small>{item?.commentListShowYn === "Y"? T.hideComments : T.viewComments}</small>
                                <b style={{ fontWeight: "bold" }}>
                                  {item?.commentList?.filter((c) => iam.memAuth == "ADMIN" || c.regId == iam.preregIdx || c?.showYn === "Y")?.length || 0}
                                </b>
                              </button>
                            )}
                           {(item.regId == iam.preregIdx || iam.memAuth == "ADMIN") && (
                            //  <button className="reply_del_btn" onClick={(e) => removeQna("T_QUESTION", item)} >
                            <button className="reply_del_btn" onClick={(e) => removeQna(item)} >
                               <img src={replydelImg} alt={T.delete} />
                               <span>{item?.preIdx ? T.recallPreQuestion : T.delete}</span>
                             </button>
                           )}
                          </div>
                      </div>
                      <div className={cx({ comment_write_box: true, active: item?.showCommentWriteBox == true })} >
                        <div className="comment_write_box_top">
                          <h4><span>{T.writeComment}</span></h4>
                          <p> {questionReplyContent[`answerContent-${item.idx}`]?.length || 0}/300 </p>
                        </div>
                        <div className="comment_write_box_flex" style={{ alignItems: "flex-end" }} >
                          <TextareaAutosize
                            type="text"
                            maxLength="300"
                            style={{ overflowY: "hidden" }}
                            placeholder={T.commentPlaceholder}
                            aria-label={T.commentPlaceholder}
                            aria-describedby="button-addon2"
                            value={ questionReplyContent[ `answerContent-${item.idx}` ] || "" }
                            onChange={(e) => changeReplyContent(item, e.target.value) }
                          />
                          <div className="comment_btn_box">
                            <button className="comment_btn_cancel" onClick={(e) => setShowCommentWriteBox(item, false)} >{T.cancel}</button>
                            <button className="comment_btn_save" id="button-addon2" onClick={(e) => questionReply(item)} >{T.submit}</button>
                          </div>
                        </div>
                      </div>
                    </div>
    {item?.commentListShowYn === "Y" && (
                      <Fragment>
                        {item?.commentList?.filter((c) => {
                          // 관리자는 모든 댓글 표시
                          if (iam.memAuth == "ADMIN") {
                            return true;
                          }
                          // 참가자: 본인 댓글 또는 공개된 댓글만 표시
                          const isMyComment = c.regId == iam.preregIdx;
                          const isPublicComment = c?.showYn === "Y";
                          
                          return isMyComment || isPublicComment;
                        })?.map((comment, j) => (
                          <Fragment key={comment?.idx ?? `${item?.idx || 'comment'}-${j}`}>
                            <div
                              className={cx({
                                comment_list_box: true,
                                on:
                                  iam.memAuth == "ADMIN" &&
                                  comment.showYn === "N",
                                active: toggleMenu[comment.idx],
                              })}
                            >
                              <img src={replystImg} alt={T.comment} />
                              <div className="comment_list_box_inner">
                                <pre>
                                  {/* <strong>Online Support : </strong> */}
                                  {comment.contents}
                                </pre>

                                <div className="question_list_box_date_reply">
                                  <span className="question_list_box_date_reply_span">
                                    {iam?.memAuth == 'ADMIN' ?  (comment?.name != null && comment?.name != "" ? comment?.name : T.guest) + ' - ' : ''}{moment(comment.regDate).format("MM.DD HH:mm:ss")}
                                  </span>
                                  <div className="question_list_box_desc_btn">
                                    {iam.memAuth == "ADMIN" && (
                                      <div className="qna_check_box">
                                        <input
                                          type="checkbox"
                                          id={`switch_q${i}_comment${j}`}
                                          name="switch"
                                          className="input__on-off"
                                          value={comment.showYn}
                                        />
                                        <label
                                          htmlFor={`switch_q${i}_comment${j}`}
                                          className="label__on-off label__on"
                                          style={{
                                            backgroundColor:
                                              comment?.showYn === "Y"
                                                ? "#7758fa"
                                                : "#999999",
                                          }}
                                          onClick={(e) =>
                                            questionCommentSetShow(
                                              comment
                                            )
                                          }
                                        >
                                          <span
                                            className="marble"
                                            style={{
                                              right:
                                                comment?.showYn === "Y"
                                                  ? "3px"
                                                  : "19px",
                                            }}
                                          ></span>
                                        </label>
                                      </div>
                                    )}
                                    <button
                                      className="reply_del_btn"
                                      onClick={(e) =>
                                        removeComment(comment)
                                      }
                                    >
                                      {(comment.regId == iam.preregIdx ||
                                        iam.memAuth == "ADMIN") && (
                                        <Fragment>
                                          <img
                                            src={replydelImg}
                                            alt={T.delete}
                                          />
                                          <span>{T.delete}</span>
                                        </Fragment>
                                      )}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Fragment>
                        ))}
                      </Fragment>
                    )}
                   </div>
               </Fragment>
           </Fragment>
          ))}
          
            
        {(isEmpty(visibleQuestionList) || visibleQuestionList?.length <= 0) && (
          <div
            className="nonedata_box"
            style={{ textAlign: "center", padding: "20px 0" }}
          >
            <img
              src="https://cdn.onoffevent.com/common/icon_nonedata.svg"
              alt=""
              style={{ width: "70px" }}
            />
            <p style={{ fontSize: "13px", color: "#333333" }}>
              {T.noQuestions}
            </p>
          </div>
        )}
      </div>
          {remainListCount > 0 && (
            <div className="detail_morebtn">
              <a onClick={(e) => onSetNextPage(e)}>{T.more}</a>
            </div>
          )}
        </div>
        {/* </PerfectScrollbar> */}
      </div>
    </Fragment>
  );
};

const CMessage = styled.div`
  margin-bottom: 0.5rem;
  span {
    margin-right: 0.5rem;
    margin-left: 0.5rem;
  }
`;
